module.exports = __webpack_public_path__ + "img/banner-partner-img-sp.f5bbb715.svg";